const state = {
  videoSrc: '',//视频 的播放地址
}

const mutations = {

}

const actions = {
  setVideoSrc: ({state, commit}, src) => {
    if(src){
      state.lastVideoSrc = state.videoSrc = src
    }else {
      state.videoSrc = ''
    }
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
